import Footer from "@/components/footer";
import Navbar from "@/components/navbar";

export default function About() {
  return (
    <div>
      <Navbar />
      <main className="mx-auto max-w-3xl px-4 sm:px-6 py-16">
        <h1 className="text-3xl font-semibold tracking-tight">About</h1>
        <p className="mt-4 text-muted-foreground">
          I’m Jenn, a software engineer focused on building robust, user-centered web apps. I love
          well-structured systems, clear interfaces, and shipping quality.
        </p>
        <div className="mt-10 grid sm:grid-cols-2 gap-6">
          <div className="rounded-xl overflow-hidden ring-1 ring-border">
            <img
              className="w-full h-full object-cover"
              src="https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=1600"
              alt="Workspace"
            />
          </div>
          <div className="rounded-xl overflow-hidden ring-1 ring-border">
            <img
              className="w-full h-full object-cover"
              src="https://images.pexels.com/photos/3861964/pexels-photo-3861964.jpeg?auto=compress&cs=tinysrgb&w=1600"
              alt="Design notes"
            />
          </div>
        </div>
        <div className="mt-8 space-y-2">
          <p>
            Core skills: TypeScript, React, Node, Hono, SQL/Drizzle, design systems, accessibility.
          </p>
          <p>Values: clarity, empathy, craft, and continuous improvement.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
